<template>
    <v-flex xs12>
        <v-card class="pa-5" flat>
        <h1 class="fonte">INDICAÇÕES</h1>
        <v-divider class="mt-3"></v-divider>
        <v-container grid-list-md text-xs-center>
            <v-layout row wrap>
                <v-flex xs12 sm4 md3>
                    <CardStatus title="Atendidas" icon="check" color="#00897B" :total="sumario.atendidas"></CardStatus>
                </v-flex>
                <v-flex xs12 sm4 md3>
                    <CardStatus title="Duração das Chamadas" icon="timelapse" color="#00894D"  :total="convertsegundos"></CardStatus>
                </v-flex>
                <v-flex xs12 sm4 md3>
                    <CardStatus title="Não atendidas" icon="hourglass_empty" color="#006989" :total="sumario.naoantendidas"></CardStatus>
                </v-flex>
                <v-flex xs12 sm4 md3>
                    <CardStatus title="Falha" icon="error_outline" color="#89003C" :total="sumario.falhas"></CardStatus>
                </v-flex>
            </v-layout>
        </v-container>
        <v-divider class="mt-3"></v-divider>
        <h1 class="fonte text-uppercase">Filtro de mensagens</h1>
        <v-container grid-list-md>
            <v-layout row wrap>
                <v-flex xs12 sm6 md6 lg6 class="elevation-0 pa-2">
                    <span class="caption">Data Inicial</span>
                    <datetime type="datetime" class="subheading" v-model="filtro.dataInicial" :phrases="{ok: 'Ok', cancel: 'Cancelar'}" format="dd/MM/yyyy HH:mm"></datetime>
                </v-flex>
                <v-flex xs12 sm6 md6 lg6 class="elevation-0 pa-2">
                    <span class="caption font-weight-regular">Data Final</span>
                    <datetime type="datetime" class="subheading" v-model="filtro.dataFinal" :phrases="{ok: 'Ok', cancel: 'Cancelar'}" format="dd/MM/yyyy HH:mm"></datetime>
                </v-flex>
                <v-flex xs12 sm6 md6 lg6  class="elevation-0 pa-2 mt-2">
                    <v-text-field label="Número que foi enviado" placeholder="Insira o número" color="teal" v-model="filtro.phone"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6 lg6  class="elevation-0 pa-2">
                    <v-select v-model="filtro.status" :items="status" item-text="text" color="teal" item-value="value" placeholder="Selecione o status" multiple
                    chips persistent-hint></v-select>
                </v-flex>
            </v-layout>
            <v-layout row wrap>
                <v-flex sm4 class="elevation-0 pa-2">
                    <v-btn :loading="isLoadingBusca" :disabled="isLoadingBusca" color="fundo" @click="getChamadas" block large round>
                    <v-icon left>search</v-icon>Pesquisar
                    <template v-slot:loader>
                        <span class="custom-loader">
                            <v-icon light>cached</v-icon>
                        </span>
                    </template>
                    </v-btn>
                </v-flex>
            </v-layout>
        </v-container>
        <v-divider class="mt-3"></v-divider>
        <v-layout row wrap pt-3>
            <v-flex xs6 sm6>
            <h1 class="fonte">Ligações</h1>
            </v-flex>
            <v-flex xs6 sm6>
                <v-text-field v-model="search" color="teal" append-icon="search" label="Pesquisar" single-line hide-details></v-text-field>
            </v-flex>
        </v-layout>
        <v-layout row wrap pt-3>
            <v-flex xs12>
                <v-data-table :headers="headers" :items="chamadas" :search="search" hide-actions:loading="isLoadingBuscaTeal">
                    <template slot="items" slot-scope="props">
                        <td class="text-xs-center">{{ dataFormatada(props.item.createdAt) }}</td>
                        <td class="text-xs-center">{{ props.item.src_name }}</td>
                        <td class="text-xs-center">{{ props.item.src_phone }}</td>
                        <td class="text-xs-center">{{ props.item.dst_name}}</td>
                        <td class="text-xs-center">{{ props.item.dst_phone }}</td>
                        <td class="text-xs-center">{{ props.item.status }}</td>
                        <td class="text-xs-center">{{ duracaoChamada(props.item.duration) || 0 }}</td>
                        <td class="text-xs-center">
                            <v-btn v-if="validURL(props.item.audiolink)" fab small flat color="teal" @click="openPlayer(props.item)">
                                <v-icon>play_circle_filled</v-icon>
                            </v-btn>
                            <v-icon small v-else>cloud_off</v-icon>
                            </td>
                    </template>
                    <v-alert slot="no-results" :value="true" color="error" icon="warning">Sua busca por &quot;{{ search }}&quot; não retornou resultados.</v-alert>
                </v-data-table>
            </v-flex>
        </v-layout>
        <v-layout row wrap justify-center>
            <div class="text-xs-center mb-1 pb-1">
                <v-btn fab dark small color="fundo" :disabled="disabledLeft" @click="arrow()">
                    <v-icon dark>chevron_left</v-icon>
                </v-btn>
                <v-chip>{{ filtro.page }}</v-chip>
                <v-btn fab dark small color="fundo" :disabled="disabledRight" @click="next()">
                    <v-icon dark>chevron_right</v-icon>
                </v-btn>
            </div>
            <v-bottom-sheet inset v-model="sheetPlayer">
                <audio @timeupdate="onTimeUpdateListener" ref="audioChamada"></audio>
                <v-card tile style="padding: 0px;">
                    <v-progress-linear :value="currentTime/totalTime*100" class="my-0 progressAudio" height="8" color="teal" @click="changeProgressAudio($event)" ref="timeAudio"></v-progress-linear>
                    <v-list>
                        <v-list-tile>
                            <v-list-tile-content>
                                <v-list-tile-title>Origem: {{chamadaAtual.src_phone}} - Destino: {{chamadaAtual.dst_phone}}</v-list-tile-title>
                                <v-list-tile-sub-title> Data: {{dataFormatada(chamadaAtual.dataevento)}} <a :href="chamadaAtual.audiolink">Link do áudio</a></v-list-tile-sub-title>
                            </v-list-tile-content>
                            <v-spacer></v-spacer>
                            <v-list-tile-action :class="{ 'mx-5': $vuetify.breakpoint.mdAndUp }">
                                <v-btn icon v-if="play" @click="pauseAudio">
                                    <v-icon>pause</v-icon>
                                </v-btn>
                                <v-btn icon v-else @click="playAudio">
                                    <v-icon>play_arrow</v-icon>
                                </v-btn>
                            </v-list-tile-action>
                        </v-list-tile>
                    </v-list>
                </v-card>
            </v-bottom-sheet>
        </v-layout>
    </v-card>
</v-flex>
</template>


<script>
import CardStatus from "../../CardStatus";
import { mapActions, mapGetters } from "vuex";
import moment from "moment-timezone";
import * as helpers from "./../../../helpers/helpers";

export default {
  components: {
    CardStatus
  },
  data() {
    return {
      dados: [],
      search: "",
      sheetPlayer: false,
      dadosChamada: {},
      currentTime: 0,
      totalTime: 0,
      play: false,
      chamadaAtual: {},
      disabledRight: false,
      dialogResponses: false,
      filtro: {
        dataInicial: moment(new Date()).format("YYYY-MM-DD") + "T00:00",
        dataFinal: moment(new Date()).format("YYYY-MM-DD") + "T23:59",
        hoje: moment(new Date()).format("YYYY-MM-DD"),
        phone: "",
        status: "",
        page: 1
      },
      isLoadingBusca: false,
      isLoadingBuscaTeal: false,
      status: [
        { text: "Atendido", value: "ANSWERED" },
        { text: "Não Atendido", value: "NO ANSWER" },
        { text: "Falhou", value: "FAILED" }
      ],
      headers: [
        { text: "Data e Hora", value: "createdAt", align: "center" },
        { text: "Nome Origem", value: "src_name", align: "center" },
        { text: "Origem", value: "src_phone", align: "center" },
        { text: "Nome Destino", value: "dst_name", align: "center" },
        { text: "Destino", value: "dst_phone", align: "center" },
        { text: "Status Origem", value: "status", align: "center" },
        { text: "Duração", value: "duracao", align: "center" },
        { text: "Detalhes", value: "detahes", align: "center" }
      ],
      mensagens: [
        {
          value: false,
          datahora: "Frozen Yogurt",
          origem: 159,
          destino: 6.0,
          statusorigem: 24,
          duracao: 4.0,
          detahes: 4.0
        }
      ]
    };
  },
  async mounted() {
    this.getChamadas();
  },
  computed: {
    convertsegundos(){
       return helpers.convertSeconds(this.sumario.duracao)
    },
      sumario()
      {
          return this.$store.getters.getUltimasChamadas.sumario
      },

    //...mapGetters(['getUltimasChamadas']),
    chamadas() {
      return this.$store.getters.getUltimasChamadas.dados
    },
    total() {

      let soma = 0;

      if (this.chamadas.length == 0) {
        return 0;
      }

      this.chamadas.map((c, i) => {
        if (c.duration) soma += c.duration;
      });

      return helpers.convertSeconds(soma);
    },
    tempoMedio() {
      let soma = 0;

      if (this.chamadas.length == 0) {
        return 0;
      }

      this.chamadas.map((c, i) => {
        if (c.duration) soma += c.duration;
      });

      return helpers.convertSeconds((soma/this.chamadas.length));
    },
    formatDateInicial() {
      if (!this.filtro.dataInicial) return null;
      const [year, month, day] = this.filtro.dataInicial.split("-");
      return `${day}/${month}/${year}`;
    },
    formatDateFinal() {
      if (!this.filtro.dataFinal) return null;
      const [year, month, day] = this.filtro.dataFinal.split("-");
      return `${day}/${month}/${year}`;
    },
    disabledLeft() {
      if (this.filtro.page == 1) {
        return true;
      }
    }
  },
  methods: {
    ...mapActions(["buscaLigacoes"]),

   async dadosDataTable(item){
         this.item.dados = this.dados
    },

    dataFormatada(data) {
      return moment(data).format("DD/MM/YYYY HH:mm:ss");
    },
    async next() {
      this.filtro.page++;
      let status = await this.getChamadas();

      if (!status) {
        this.filtro.page--;
        this.isLoadingBusca = false;
        this.isLoadingBuscaTeal = false;
        this.$eventHub.emit("snackBar", {
          message: "Não tem dados na próxima página"
        });
      }
    },
    async arrow() {
      this.filtro.page--;
      await this.getChamadas();
    },
    async getChamadas() {
      this.isLoadingBusca = true;
      this.isLoadingBuscaTeal = "teal";
      let resp = await this.buscaLigacoes(this.filtro);
      //console.log(resp)
      this.isLoadingBusca = false;
      this.isLoadingBuscaTeal = false;
      return resp;
    },

    openPlayer(chamada) {
      var _this = this;
      this.sheetPlayer = !this.sheetPlayer;
      if (this.sheetPlayer) {
        this.chamadaAtual = chamada;
        this.$refs.audioChamada.src = chamada.audiolink;

        _this.$refs.audioChamada.addEventListener(
          "loadedmetadata",
          function() {
            _this.$refs.audioChamada.setAttribute(
              "data-time",
              _this.$refs.audioChamada.duration
            );
            _this.totalTime = _this.$refs.audioChamada.duration;
            _this.$refs.audioChamada.play();
            _this.play = true;
          },
          false
        );
      } else {
        this.$refs.audioChamada.pause();
        this.play = false;
        this.totalTime = 0;
        this.currentTime = 0;
        this.chamadaAtual = {};
      }
    },

    onTimeUpdateListener() {
      this.currentTime = this.$refs.audioChamada.currentTime;
    },
    playAudio() {
      this.$refs.audioChamada.play();
      this.play = true;
    },
    pauseAudio() {
      this.$refs.audioChamada.pause();
      this.play = false;
    },
    changeProgressAudio(event) {
      const tamanhoTotal = this.$refs.timeAudio.$el.clientWidth;
      const offsetClick = event.layerX;

      const porcentagem = (offsetClick / tamanhoTotal) * 100;

      const novoTempo = (this.totalTime / 100) * porcentagem;

      this.$refs.audioChamada.currentTime = novoTempo;
    },

    validURL(str) {
      let regex = /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
      if (!regex.test(str)) {
        return false;
      } else {
        return true;
      }
    },

    duracaoChamada(seconds) {
      return helpers.convertSeconds(seconds);
    }
  },

  watch: {
    sheetPlayer(val, oldVal) {
      if (!val) {
        this.$refs.audioChamada.pause();
        this.play = false;
        this.totalTime = 0;
        this.currentTime = 0;
        this.chamadaAtual = {};
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
.d-flex {
  display: flex;
  margin: 0 20px 100px 20px;
  padding-top: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/user/protaxi/Resumo.vue